import { render } from "./TeleportTemplate.vue?vue&type=template&id=0c149197"
import script from "./TeleportTemplate.vue?vue&type=script&lang=js"
export * from "./TeleportTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__